import styled from 'styled-components';
import { ImgSize } from './types';

type ImgProps = {
	$size?: ImgSize;
};

const getSize = (size: string) => {
	switch (size) {
		case 'verySmall':
			return '16px';
		case 'small':
			return '21px';
		case 'medium':
			return '24px';
		case 'large':
			return '32px';
		case 'giant':
			return '60px';
		default:
			return '24px';
	}
};

export const Img = styled.img<ImgProps>`
	height: ${({ $size }) => getSize($size || 'medium')};
	width: ${({ $size }) => getSize($size || 'medium')};

	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;
`;
